// 인트로 오버레이 연결부. 오버레이 자체(CTA·프롤로그 영상·로딩 화면)는 index.html 안에서 번들보다 먼저 돌고,
// 여기서는 게임 준비 상태(assetStatus)를 넘기는 일과 던전 입장 대기 화면만 맡는다.
// ?qa·?start=…·자동화 브라우저에서는 index.html이 오버레이를 만들지 않으므로(window.__dhIntro.enabled=false) 모두 아무 일도 하지 않는다.
import type { AssetStatus } from '../render/assets';

/** index.html 인라인 스크립트가 노출하는 창구 */
export interface IntroApi {
  enabled: boolean;
  active: boolean;
  progress(p: number): void;
  /** 게임이 완전히 준비됐다(마을 환경 아트 교체 + Kael 부착, 또는 Kael 실패 경로에서 시작 버튼이 켜짐) */
  ready(): void;
  veil(text: string | null): void;
  abort(): void;
}

const introApi = (): IntroApi | undefined => (window as unknown as { __dhIntro?: IntroApi }).__dhIntro;

/** 인트로가 켜진 세션인가(실사용자 경로). 꺼진 세션은 기존 부팅 순서를 그대로 쓴다. */
export function introEnabled(api: IntroApi | undefined = introApi()): boolean {
  return !!api && api.enabled;
}

/** 에셋 상태를 오버레이로 흘려 보낸다. 준비되면(ready 또는 failed) 한 번 알리고 멈춘다. 반환값은 중단 함수. */
export function bindIntro(status: Pick<AssetStatus, 'progress' | 'ready' | 'failed'>, api: IntroApi | undefined = introApi(), everyMs = 100): () => void {
  if (!introEnabled(api)) return () => {};
  const a = api!;
  const push = (): boolean => {
    // 준비 신호는 실패 경로(간이 모델로 시작)에서도 같다: 그때 타이틀의 시작 버튼이 이미 켜져 있다
    if (status.ready || status.failed) { a.ready(); return true; }
    a.progress(status.progress);
    return false;
  };
  if (push()) return () => {};
  const id = setInterval(() => { if (push()) clearInterval(id); }, everyMs);
  return () => clearInterval(id);
}

/** 인트로가 걷히면 풀리는 약속. 인트로가 꺼진 세션(QA·자동화)이면 undefined(기다리지 않는다). */
export function introDone(api: IntroApi | undefined = introApi(), target: Pick<Window, 'addEventListener'> = window): Promise<void> | undefined {
  if (!introEnabled(api) || !api!.active) return undefined;
  return new Promise<void>((resolve) => target.addEventListener('dh-intro-done', () => resolve(), { once: true }));
}

/** 던전 자원이 아직이면 대기 화면을, 아니면 걷는다. */
export function introVeil(text: string | null, api: IntroApi | undefined = introApi()): void {
  if (introEnabled(api)) api!.veil(text);
}

/** 시작 실패 안내 화면이 오버레이 아래에 가리지 않게 즉시 걷는다. */
export function introAbort(api: IntroApi | undefined = introApi()): void {
  if (api) api.abort();
}
